export default {
	noticeContent:[
		'<br>在您注册成为顺丰速运会员的过程中，您需要通过点击同意的形式在线签署<span style="font-weight:bold">《顺丰速运服务条款》、《顺丰速运隐私政策》</span>，请您务必仔细阅读、充分理解条款内容后再点击同意（尤其是以粗体并下划线标识的条款，因为这些条款可能会明确您应履行的义务或对您的权利有所限制）。<br><br>',
		'请您注意：如果您不同意上述服务条款、隐私政策或其中任何约定，请您停止注册。如您阅读并点击同意即表示您已充分阅读、理解并接受其全部内容，并表明您也同意顺丰速运可以依据以上隐私政策来处理您的个人信息。如您对以上服务条款、隐私政策有任何疑问，您可联系顺丰速运客服。<br><br>'
	],
	serverContent: { // 登录页面专用 顺丰速运服务条款 正文
		title: '顺丰速运服务条款',
		content: [{
			name: '<b>尊敬的用户：</b>',
			list: [
				'欢迎使用顺丰速运微信服务号系统平台（以下简称"我的顺丰"），为了使您获得愉悦和安全的服务体验，在此列明以下服务条款，详述了您使用本网站的服务所须遵守的条款和条件，请您在使用"我的顺丰"或加入会员之前仔细阅读。'
			]
		},
			{
				name: '<b>服务条款：</b>',
				list: []
			},
			{
				name: '<b>一、特别申明</b>',
				list: [
					'1、"我的顺丰"是由顺丰速运有限公司拥有及营运，本网站将完全按照以下发布的服务条款和操作规则严格执行，用户必须完全同意所有服务条款，才能注册成为"我的顺丰"的正式会员，用户在进行注册过程中点击"同意协议并进入下一步"即表示用户已完全知悉并接受全部服务条款。 顺丰速运有权根据业务需要酌情修订"条款"，并在其网站上予以公告。如用户不同意相关修订，请用户立即停止使用"服务"。经修订的"条款"一经在顺丰速运网站公布，即产生效力。如用户继续使用"服务"，则将视为用户已接受经修订的"条款"，当用户与顺丰速运发生争议时，应以最新的"条款"为准。 本服务协议内容包括协议正文及所有顺丰速运已经发布或将发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。',
					'2、"我的顺丰"仅提供相关的下单、查询等自助服务，除此之外与服务有关的上网所需设备（包括个人电脑、手机、其它与接入互联网或移动网有关的上网装置）及所需的费用（与此服务相关的电话费、上网费、为使用移动网而支付的手机费等）均应由用户自行承担。'
				]
			},
			{
				name: '<b>二、用户条款</b>',
				'list': [
					'1、非会员指未完成注册，但通过上网设备（包括但不限于电脑、手机、平板电脑等）访问"我的顺丰"并使用有限服务的用户。如已注册成为会员，但在使用服务时未履行登录手续，其行为会被视为非会员行为。',
					'2、"我的顺丰"允许非会员使用有限的服务，具体服务包括下单寄件服务、查询快件服务、以运单号订阅所关联的快件信息等。',
					'3、非会员用户可通过手机验证并设置密码等会员注册方式成为会员。'
				]
			},
			{
				name: '<b>三、会员注册</b>',
				list: [
					'1、用户进行注册时，必须填写准确、真实、有效的个人资料，如果提供的资料包含有不正确的信息，本网站保留结束用户使用网络服务资格的权利。倘若用户提供任何不真实、不准确、不完整或不能反映当前情况的资料，或顺丰速运有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，顺丰速运有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对"服务"(或其任何部份) 以任何形式使用。用户的用户名中不得包含违反国家法律法规、涉嫌侵犯他人权利或干扰顺丰速运正常运营秩序等的相关信息；同一个用户名只能注册一个账号，并且验证该账号有效的手机号或邮箱未用于其它账号的验证。用户注册时的手机号码是会员身份的唯一标识，为保证用户账号安全，如手机号码发生变动，请及时修改，以免造成不必要的损失',
					'2、用户按照注册页面提示填写信息、设置密码、阅读并同意本协议并完成全部注册程序后或以其他"我的顺丰"允许的方式实际使用顺丰速运"我的顺丰"服务时，用户即成为会员（亦称会员），顺丰速运"我的顺丰"根据会员用户名和密码确认会员身份。用户对该账号和密码的安全负全部责任，且应当对以其用户账号进行的所有活动和事件负法律责任。用户若发现任何非法盗用会员账号、密码或存在安全漏洞的情况，请立即通告本网站。用户理解顺丰速运对用户的请求采取行动需要合理时间，顺丰速运对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。',
					'3、用户注册成功，并已设置相应密码后，可以随时登陆网站账户信息页面更改其基本信息。'
				]
			},
			{
				name: '<b>四、使用规则</b>',
				list: [
					'1、用户在使用"我的顺丰"服务过程中，必须遵循以下规定，否则"我的顺丰"有权做出独立判断，立即取消该用户的会员资格并注销其用户账号：',
					'（1）遵守国家法律法规、当地法规及互联网相关规定。',
					'（2）遵守所有与运单及查询服务有关的协议、规定、程序以及本网站的服务条款。',
					'（3）不使用网络服务作非法用途。',
					'（4）不得利用"我的顺丰"的服务系统进行任何可能对互联网或移动网络正常运转造成不利影响的行为。',
					'（5）不得利用"我的顺丰"提供的下单及查询服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料。',
					'（6）用户在申请使用"我的顺丰"下单及查询服务时，必须提供准确的个人资料，如个人资料有任何变动，必须及时更新。',
					'（7）允许"我的顺丰"通过电子邮件或其他方式向会员发送相关商业信息。',
					'（8）不得进行有损本网站利益的行为。',
					'（9）不得通过盗取账号、密码，诈骗等不正当手段获得会员信息。',
					'（10）不得出借、转让会员账号给他人。',
					'（11）不得以会员账号当作商品进行交易（如出售、拍卖会员账号等）。',
					'（12）不得在使用"我的顺丰"时离开网站，确保在每个上网时段结束时，以正确步骤离开网站。',
					'2、"我的顺丰"针对某些特定的服务的使用通过各种方式（包括但不限于网页公告、电子邮件、手机短信提醒等）做出的任何声明、通知、警示等内容视为本条款的一部分，用户如果使用该服务，视为用户同意该等声明、通知、警示的内容。',
					'3、对于用户通过"我的顺丰"下单及查询服务上传到本网站上可公开获取区域的任何内容，用户同意本网站在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。',
					'4、结束服务：',
					'（1）用户或"我的顺丰"可随时根据实际情况中断一项或多项网络服务。"我的顺丰"不需对任何个人或第三方负责而随时中断服务。如用户对以后的条款修改有异议，或对"我的顺丰"的服务不满，可以行使以下权利：',
					'① 停止使用"我的顺丰"的网络服务。',
					'② 通告"我的顺丰"停止对用户的服务。',
					'（2）结束用户服务后，用户使用网络服务的权利马上终止。从结束服务时起，"我的顺丰"没有义务传送任何未处理的信息或未完成的服务给用户或第三方。'
				]
			},
			{
				name: '<b>五、会员稳私政策</b>',
				list: [
					'尊重及保护会员隐私是"我的顺丰"的一项基本政策，会员同意"我的顺丰"按以下条款所列明的用途，使用会员的资料。',
					'1、"我的顺丰"保证一定不会在未经会员同意授权的情况下公开、编辑及透漏会员的个人信息，但下列情况除外：',
					'（1）获得会员的明确授权；',
					'（2）根据有关的法律法规要求；',
					'（3）按照相关政府主管部门的要求；',
					'（4）为维护社会公众的利益；',
					'（5）为维护顺丰速运的合法权益。',
					'2、用户名和密码',
					'当用户注册成为"我的顺丰"的会员并设置密码后，用户能通过密码来使用会员账号，如果泄漏了密码，则可能会丢失用户的个人识别信息，并且有可能导致对用户不利的司法行为。因此不管任何原因使密码安全受到危及，用户应该立即与"我的顺丰"取得联系。',
					'3、下单资料',
					'当会员在"我的顺丰"下单时，需要会员提供真实、准确、完整的资料如寄送地址、托寄物资料、联系人、联系电话、付款方式等信息，可以让本网站能处理运单以及运单状态。',
					'4、会员电子邮件/短信',
					'（1）"我的顺丰"保留通过电子邮件、手机短信、邮寄宣传册等形式，对本网站注册会员发送信息、活动等告知服务的权利。如果用户在"我的顺丰"注册，表明用户已默示同意接受此项服务。',
					'（2）如果会员不想收到相关的通讯，可以向"我的顺丰"提出退阅申请，并注明E-mail地址、手机号或相关地址信息，"我的顺丰"会在收到申请后为会员办理退阅。',
					'5、下单行为',
					'"我的顺丰"跟踪IP地址仅仅只是为了安全的必要。如果没有发现任何安全问题，将及时删除本网站收集到的IP地址。网站会跟踪全天的页面访问数据。全天页面访问数据被用来反映网站的流量，"我的顺丰"可以为未来的发展制定计划（例如，增加服务器）。',
					'6、第三方',
					'"我的顺丰"不会向任何第三方提供、出售、出租、分享和交易会员的个人信息，除非第三方和"我的顺丰"一起为网站和用户提供服务并且在该服务结束后会将被禁止访问包括其以前能够访问的所有这些资料。当"我的顺丰"被法律强制或依照政府要求提供会员的信息时本网站将善意地披露会员的资料。',
					'7、信息的存储和交换',
					'会员信息和资料被收集和存储在放置于中国的服务器上。只有为了做备份的需要时，"我的顺丰"才可能需要将会员的资料传送到别国的服务器上。',
					'8、外部链接',
					'当会员点选其他网站链接或广告时，会进入第三者的网站，"我的顺丰"对那些网站的隐私保护措施不负任何责任。',
					'9、安全',
					'"我的顺丰"有相应的安全措施来确保本网站掌握的信息不丢失、不被滥用和编造。这些安全措施包括向其它服务器备份数据和对会员密码加密。尽管本网站有这些安全措施，但请注意在因特网上不存在"完善的安全措施"。"我的顺丰"保留在任何时间拒绝履行任何有疑问或被怀疑有信用欺诈嫌疑的下单。'
				]
			},
			{
				name: '<b>六、知识产权声明</b>',
				list: [
					'1、"我的顺丰"网站内所有内容，包括所有文字、图片、图形、音频、视频等都是本网站财产，均受版权、商标和其它财产所有权法律的保护。未经本网站同意，任何企业或个人均无权复制、下载、传输、再造本网站任何内容，也不得提供给第三者使用，否则应负所有法律责任。违反上述声明而给本公司造成损失的，本公司将依法追究其法律责任。',
					'2、"我的顺丰"为提供下单及查询服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。'
				]
			},
			{
				name: '<b>七、免责声明</b>',
				list: [
					'1、用户明确同意使用"我的顺丰"下单及查询服务所存在的风险及产生的一切后果将完全由用户自己承担。',
					'2、"我的顺丰"不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性、安全性、出错发生均不作担保。',
					'3、"我的顺丰"有义务在技术上保证本网站的正常运行，而对于因不可抗力或本网站不能控制的原因造成的下单及查询服务中断或其它缺陷，"我的顺丰"不承担任何责任，但本网站会尽力协助处理以减少因此给用户造成的损失和影响。',
					'4、由于用户自己将会员密码告知他人、与他人共享注册账户、转借或出让账户给他人使用，由此导致任何个人信息的泄露、快件损失等损失由会员自行承担，"我的顺丰"及顺丰速运无需承担任何责任。',
					'5、由于用户向"我的顺丰"提供错误、不完整、不实信息等造成不能正常使用本网站服务或遭受任何其他损失，"我的顺丰"无需承担任何责任。',
					'6、"我的顺丰"不担保所有由顺丰速运发出的短信不会发生遗失或未送达。由于短信运营商网络运转不正常，天灾人祸、战争等原因造成网络瘫痪或者接收短信的用户手机网络通道不畅通等不可抗力因素，而导致短信无法即时、准确地送达用户，顺丰速运无须承担相应责任。',
					'7、"我的顺丰"网站及其内容是在现有资料的基础上提供，"我的顺丰"只提供下单及查询服务，因此本网站并不会因网站内容所引起的任何损失而作直接、间接、意外、衍生性的及惩罚性的损害赔偿 （包括金钱利益及无形的损失）及负上法律责任（除了法律上已隐含的条例）。',
					'8、"我的顺丰"会提供其他网站的链接，这些链接的网站并非由"我的顺丰"控制，故不对该网站的内容、其链接网站的内容及其内容的更新及转变承担任何责任，这些网站的使用及内容也不代表"我的顺丰"的立场。',
					'9、您注册时的手机号码是会员身份的唯一标识，如手机号码有变动，请及时修改。如因用户自身原因未及时修改手机号而造成的账号被盗、个人信息泄露等损失，"我的顺丰"将不承担相关责任，但本网站会尽力协助用户处理以减少因此给用户造成的影响。'
				]
			},
			{
				name: '<b>八、通告</b>',
				list: [
					'"我的顺丰"会通过网页公告或电子邮件或手机短信传送等方式，把通告传送给用户，该等通告于发送之日即视为已送达收件人。'
				]
			},
			{
				name: '<b>九、违约赔偿及责任限制</b>',
				list: [
					'1、因用户违反有关法律、法规或本网站的服务条款而令"我的顺丰"招致损失，用户同意承担由此造成的损害赔偿责任。',
					'2、用户同意"我的顺丰"不会为用户因使用本网站而招致的损失负上任何法律责任，也同意放弃追究"我的顺丰"任何赔偿。如果此项声明不适用于个别的例子，"我的顺丰"的责任不会超过用户在本网站下单所付出的金额。'
				]
			},
			{
				name: '<b>十、法律监管</b>',
				list: [
					'1、本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。',
					'2、如发生"我的顺丰"服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它合法条款则依旧保持对用户产生法律效力和影响。',
					'3、如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向深圳市福田区人民法院提起诉讼。'
				]
			}]
	},
	privacyContent: { // 登录页面专用 隐私政策 正文
		title: '隐私政策',
		content: [
			{
				name: '尊敬的用户，我们对顺丰《隐私政策》进行了如下更新。本次更新主要集中在增加儿童个人信息保护相关内容，明确了我们对儿童个人信息的收集和使用方式，设立了儿童个人信息保护专人负责制度。',
				list: [
					'<br>最近更新日期：2019年12月6日',
					'如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：',
					'电 话：95338',
					'<br><b>特别提示</b>',
					'<br><b>本政策适用于您所使用的顺丰速运有限公司及其关联公司（以下统称“顺丰”）提供的物流服务。顺丰一直非常重视保护客户的个人信息。在您使用顺丰的服务前，请务必仔细阅读并理解本政策，尤其是其中加粗的条款。当您使用顺丰的服务时，或在本政策更新后继续使用顺丰的服务，即视为您已经阅读、理解并同意本政策及其更新的版本，同意我们按照本政策的约定处理您的个人信息。如您不同意本政策的任何条款，您应立即停止使用顺丰的服务。</b>',
					'<br>本政策将帮助您了解以下内容：',
					'1、我们如何收集和使用您的个人信息',
					'2、我们如何使用Cookie和同类技术',
					'3、我们如何共享、转让、公开披露您的个人信息',
					'4、我们如何保护和保存您的个人信息',
					'5、您的权利',
					'6、我们如何处理儿童的个人信息',
					'7、您的个人信息如何在全球范围转移',
					'8、本政策如何更新',
					'9、如何联系我们'
				]
			},
			{
				name: '<br><b>一、我们如何收集和使用您的个人信息</b>',
				list: [
					'<br><b>个人信息</b>是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。',
					'<b>个人敏感信息</b>是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。<b>本政策中涉及的个人敏感信息，将采用加粗字体突出显示。</b>',
					'顺丰仅会出于本政策所述的以下目的，收集和使用您的个人信息： ',
					'<b>（一）核心业务功能收集和使用您个人信息的情形</b>',
					'<b>我们可能会收集、保存和使用下列与您有关的信息才能实现下述功能。如果您不提供相关信息，您将无法享受相关的顺丰服务。这些功能包括：</b>',
					'<b>1、注册账号</b>',
					'为完成创建账号，您需提供以下信息（统称“账户信息”）：您的<b>手机号、账号名称</b>/昵称、<b>账号密码</b>，我们将通过发送短信验证码来验证您的身份是否有效；您还可以补充您的生日、性别、地区，您补充的信息将有助于我们为您提供个性化的服务体验，如果您不提供这些补充信息，不会影响您使用顺丰服务的基本功能。',
					'<b>2、为您提供物流服务 </b>',
					'在您下单寄件或您的信息作为收件人被提供时，顺丰或顺丰通过其授权的业务合作伙伴收集您的以下信息：寄件人及收件人的姓名、地址、<b>联系方式</b>和货件信息（统称“运单信息”），用于提交订单、生成物流运单、收件、分拣、仓储、运输、出口清关、进口清关、以及派送货件；根据相关法律要求，我们还收集您的<b>身份证信息</b>用于核验您的身份和进出口报关。',
					'<b>如果您提供了不准确或错误的地址，在不违反相关法律法规对个人信息存储的强制要求的前提下，我们可能会使用您过往的运单信息对不准确、错误的地址信息进行补全、纠正，以节省与收/寄件人反复确认地址的时间，保证时效，避免您因快件错误派送、延迟派送而遭受损失，让您有更好的服务体验。</b>',
					'<b>此外，在为您提供收派服务的过程中，如涉及电话沟通，我们可能会对通话内容进行录音，以避免潜在纠纷。</b>',
					'<b>3、支付结算</b>',
					'在您下单后，您可以选择顺丰关联方或与顺丰合作的第三方支付机构（如顺丰金融、支付宝、微信支付以及银联、网联等支付通道，以下称“支付机构”）所提供的支付服务，我们需要将您的顺丰订单号与<b>交易金额信息</b>提供给这些支付机构以确认您的支付指令并完成支付。',
					'如您申请发票，还需提供以下信息：发票抬头、纳税人识别号、<b>收票人邮箱地址</b>，以及您根据您的开票需求提供的更多信息，如购买方信息。',
					'<b>4、消息推送</b>',
					'我们收集您的设备信息，用于向您推送快件路由信息、支付状态信息及优惠券、促销信息。您可以在手机或其他设备的“设置”或在APP、微信公众号等进行免打扰设置。',
					'<b>5、客服与售后</b>',
					'我们的客服和售后功能会使用您的账号信息和运单信息。',
					'为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的<b>账号信息、运单信息</b>核验您的身份。当您需要我们提供与您的寄件相关的客服与售后服务时，我们将会查询您的<b>运单信息</b>、货件路由信息。您有可能在与我们的客服人员沟通时，提供上述信息外的其他信息，如当您要求我们变更派送地址、联系人或<b>联系电话</b>。',
					'此外，我们还会收集您参与问卷调查时向我们提交的问卷答复信息、您在顺丰速运网站上提交“合作咨询”所提供的联系人姓名、公司名称、<b>联系电话、邮箱地址</b>及您的咨询信息。',
					'<b>6、改善我们的产品或服务</b>',
					'<b>我们可能会将收集的您的账户信息、运单信息进行数据分析以形成用户画像，向您提供更优质的服务。</b>对于从您的各种设备上收集到的信息，我们可能会将它们进行关联，以便我们能在这些设备上为你提供一致的服务。我们可能会将来自某项服务的信息与来自其他服务的信息、合法间接获取的信息及合法公开渠道获取的信息结合，或者将合法获取的您的可识别个人信息与无法识别个人的信息结合，为您提供优质服务及改善我们的产品和服务。',
					'<b>7、保障交易安全</b>',
					'为提高您使用我们的服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的<b>浏览信息、运单信息、</b>您常用的软件信息、设备信息等手段来判断您的账号风险，并可能会记录一些我们认为有风险的链接（“<b>URL</b>”）；我们也会收集您的<b>设备信息</b>（如<b>设备识别码</b>）和<b>微信ID</b>（针对从微信端使用顺丰服务的用户）对于顺丰系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。',
					'<b>（二）附加业务功能收集和使用您个人信息的情形</b>',
					'为使您更便捷地使用顺丰的服务，我们的以下附加功能可能会收集和使用您的个人信息。如果您不提供这些信息，您依然可以使用顺丰的服务，但您可能无法使用这些可以为您带来便捷的附加功能或者需要重复填写一些信息。这些附加功能包括：',
					'<b>1.语音输入</b>',
					'您可以直接使用麦克风来进行语音输入<b>运单信息</b>或与我们的客服机器人进行咨询和互动。在这些功能中我们会收集您的录音内容以识别您的寄件需求和客服与售后需求。',
					'<b>2.地图功能</b>',
					'您可使用该功能查询顺丰服务点，并使用导航功能。如您使用该功能，我们需要收集您的<b>地理位置信息。</b>',
					'<b>3.基于摄像头（相机）的附加功能</b>',
					'您可以使用这个附加功能完成扫码寄件、扫码支付功能。',
					'<b>4.基于通讯录信息的附加功能</b>',
					'您可以选择调用您的<b>通讯录信息</b>以方便您在填写运单信息时不再手动输入您通讯录中联系人的信息。',
					'上述附加功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库）、麦克风以及通讯录的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在手机等设备的“设置”中逐项查看上述权限的开启状态，并可以决定将这些权限随时开启或关闭。<b>您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述功能；如您关闭权限，我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限不会影响此前基于您的授权所进行的个人信息的处理。</b>',
					'<b>（三）间接获取、使用个人信息的情形</b>',
					'我们可能从第三方获取您授权共享的<b>账户信息</b>（头像、昵称），并在您同意本政策后将您的第三方账户与您的顺丰账户绑定，使您可以通过第三方账户直接登录并使用顺丰的服务。',
					'如您通过非顺丰页面的第三方渠道下单寄件（如号码百事通、58转转、QQ会员特权商城），顺丰将从这些第三方渠道获取您的运单信息，包括收寄件人姓名、<b>电话</b>、地址和货件信息，以便为您提供收寄件相关服务。',
					'在您向他人寄件时，请确保已获得收件人的相关授权，确保顺丰有权依据本政策处理收件人的个人信息。',
					'如我们从我们的合作伙伴获取您的个人信息，我们将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。',
					'<b>（四）其他用途</b>',
					'<b>1、顺丰可能会以电子邮件、手机短信等方式向您发送顺丰认为您可能会感兴趣的广告和其它商业信息。</b>',
					'2、我们通过技术手段对收集的您的个人信息进行去标识化处理后，去标识化处理的信息将无法识别主体，您知悉并同意，<b>我们有权使用已经去标识化的信息。在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</b>',
					'3、我们会对我们服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。',
					'4、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。',
					'5、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过在线点击授权或邮件、短信等形式事先征求您的同意。',
					'<b>（五）征得同意的例外</b>',
					'您充分知悉，在以下情形中，我们收集、使用个人信息无须征得您的授权同意：',
					'1、与国家安全、国防安全有关的；',
					'2、与公共安全、公共卫生、重大公共利益有关的；',
					'3、与犯罪侦查、起诉、审判和判决执行等有关的；',
					'4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
					'5、所收集的个人信息是个人信息主体自行向社会公众公开的；',
					'6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
					'7、根据您的要求签订和履行合同所必需的；',
					'8、用于维护所提供的服务的安全稳定运行所必需的，例如发现、处置服务的故障；',
					'9、为合法的新闻报道所必需的；',
					'10、法律法规规定的其他情形。',
					'根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。'
				]
			},
			{
				name: '<br><b>二、我们如何使用Cookie和同类技术 </b>',
				list: [
					'<b>（一）Cookie </b>',
					'为确保网站正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好等数据。',
					'我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。有关详情，请参见AboutCookies.org。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。',
					'<b>（二）网站信标和像素标签</b>',
					'除Cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的点击URL。如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好并改善客户服务。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。',
					'<b>（三）Do Not Track（请勿追踪）</b>',
					'很多网络浏览器均设有Do Not Track功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。'
				]
			},
			{
				name: '<br><b>三、我们如何共享、转让、公开披露您的个人信息</b>',
				list: [
					'<b>（一）共享 </b>',
					'1、我们不会与顺丰以外的任何公司、组织和个人分享您的个人信息，但以下情况除外： ',
					'（1）在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息；',
					'（2）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息；',
					'（3）在法律法规允许的范围内，为维护顺丰或合作伙伴、您或其他顺丰用户或社会公众利益、财产或安全免遭损害而有必要提供；',
					'（4）只有共享您的信息，才能实现我们的服务的核心功能或提供您需要的服务；',
					'（5）应您需求为您处理您与他人的纠纷或争议；',
					'（6）符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；',
					'（7）基于学术研究而使用；',
					'（8）基于符合法律法规的社会公共利益而使用。',
					'2、与我们的关联公司共享：您的个人信息可能会与顺丰的关联公司共享。我们只会共享必要的个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。 ',
					'我们的关联公司是指：不时控制顺丰速运有限公司或其实体、或被顺丰速运有限公司或其实体所控制、或与顺丰速运有限公司或其实体被共同控制之下的任何实体，其中“控制”一词意指直接或间接具备或控制50%以上投票权。',
					'3、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，我们为您提供清关服务时，我们可能与清关服务提供商共享您的个人信息以安排合作伙伴提供服务。我们只会共享提供服务所必要的个人信息，我们的合作伙伴无权将共享的个人信息用于任何其他用途。 ',
					'目前，我们的授权合作伙伴包括以下类型： ',
					'1）供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式或潜在风险、广告服务、运输、仓储、清关、末端收派、支付便利、提供客户服务、提供数据存储或数据分析服务、提供第三方附加业务功能服务（如语音输入、地图功能）或进行学术研究和调查。',
					'我们的关联公司与我们适用同样的数据合规管理制度、本政策以及相关保密和安全措施。对我们与之共享个人信息的我们的关联公司之外的公司、组织和个人，我们会与其签署严格的保密协议/数据处理协议，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。',
					'<b>（二）转让</b>',
					'我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
					'1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；',
					'2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意；',
					'3、符合与您签署的相关协议（包括在线签署的电子协议）或其他的法律文件约定所提供；',
					'4、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供。',
					'<b>（三）公开披露 </b>',
					'我们仅会在以下情况下，公开披露您的个人信息： ',
					'1、获得您明确同意后；',
					'2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。'
				]
			},
			{
				name: '<br><b>四、我们如何保护和保存您的个人信息 </b>',
				list: [
					'<b>（一）我们如何保护您的个人信息安全</b>',
					'1、我们已经取得了以下认证：国际ISO27701、国际ISO29151、国际ISO27001认证及公安部等级保护测评三级认证。 ',
					'2、顺丰成立了数据安全管理组织，采取个人信息在物理（门禁隔离、监控系统）、管理（制定信息安全体系制度、将数据分类分级、与员工签订保密协议、开展数据安全和隐私保护培训、定期开展合规自评估）和技术（通过https安全浏览方式确保传输加密、采用AES256加密技术确保数据存储加密、敏感信息内容展示脱敏、匿名化处理、系统访问部署了双因素认证访问控制机制、自动化代码检查、日志审计）等方面的安全保障措施努力保护您的个人信息不被未经授权地访问、使用、披露、修改、损坏或丢失及其它的形式的非法处理。<b>然而，没有任何一种互联网传输或电子存储方法是100%安全的。因此，尽管我们通过商业上可接受的方式来保护您的个人信息，但仍无法保证信息的绝对安全。</b>',
					'3、我们会定期组织安全应急预案演练，防止安全事件发生。若不幸发生顺丰知悉所获取并储存的数据安全受到危害时，或由于外部行为（例如黑客攻击）使用户的非公开信息被披露给不相关第三方时，尽管本政策中有其他免责规定，顺丰也会启动应急预案，组成紧急应急小组，启动流程，进行内部调查、上报并通知监管部门、以及配合监管部门工作，降低事故对用户的影响，同时会在认为适当的情况下采取推送通知、邮件、公告等形式告知相关用户，告知其被披露的信息以及顺丰对该等情况的知悉程度。',
					'<b>（二）个人信息的保存期限</b>',
					'<b>1.您的账户信息及账户内相关权益、虚拟资产信息将在您注销账户后立即删除，但个别下单渠道的账户设有一定期限的反悔期（如三十天），信息将在该期限后删除。该等信息一经删除，不可恢复。</b>',
					'<b>2.为满足您的查询需要，您的运单信息在顺丰前台系统将保留三十天到六个月不等的期限（视具体下单渠道而定），您可通过运单上标明的寄件人、收件人手机号或运单号在顺丰速运官网及您下单的渠道（如顺丰速运APP、微信公众号）查询货件路由信息，满足该期限后，我们将在顺丰前台系统中去除您的运单信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</b>',
					'<b>3.您的个人信息将在顺丰后台系统保存更长的期限，具体期限根据个人信息的类型、法律法规要求和满足本政策所述目的确定。</b>',
					'<b>4.如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</b>'
				]
			},
			{
				name: '<br><b>五、您的权利 </b>',
				list: [
					'按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利： ',
					'<b>（一）访问您的个人信息</b>',
					'您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问： ',
					'账户信息——如果您希望访问或编辑您的账户中的个人资料信息，您可以使用您在顺丰的账号和密码登录您所注册的顺丰相关网站、APP、微信公众号等查询您注册时向顺丰提供的个人信息。 ',
					'寄件记录和交易记录--您可以使用您在顺丰的账号和密码登录您所注册的顺丰相关网站、APP、微信公众号等查看您的此类信息。',
					'寄件、收件信息—你可以使用您在顺丰的账号和密码登录您所注册的顺丰相关网站、APP、微信公众号等，新建、修改、删除您的寄件地址及常用收件地址（部分渠道不支持该功能）。',
					'如您需要访问您在使用我们的产品或服务过程中产生的其他个人信息，您可以与我们联系，我们会根据本政策所列明的方式和期限响应您的请求。',
					'<b>（二）更正您的个人信息</b>',
					'当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式更正您的个人信息。',
					'如您需要更正您在使用我们的产品或服务过程中产生的其他个人信息，如修改派送地址、<b>联系电话</b>，您可以与我们的客服联系。',
					'<b>（三）删除您的个人信息 </b>',
					'在以下情形中，您可以向我们提出删除个人信息的请求：',
					'1、如果我们处理个人信息的行为违反法律法规；',
					'2、如果我们收集、使用您的个人信息，却未征得您的同意；',
					'3、如果我们处理个人信息的行为违反了与您的约定；',
					'4、如果您不再使用我们的产品或服务，或您注销了账号；',
					'5、如果我们不再为您提供产品或服务。',
					'若我们决定响应您的删除请求，我们还将同时尽可能通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。 ',
					'当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。 ',
					'<b>（四）改变您授权同意的范围 </b>',
					'每个业务功能需要一些基本的个人信息才能得以完成（见本政策“第一部分”）。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。 ',
					'您可以通过删除信息、关闭设备功能、在顺丰网站、App、微信公众号等进行隐私设置、在您的设备中设置或关闭相关权限（见本政策“第一部分”-“（二）附加业务功能收集和使用您个人信息的情形”）改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。',
					'当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。 ',
					'如果您不想接受我们给您发送的商业广告，您随时可通过以下方式取消： ',
					'<b>无论您基于何种原因拒绝接收相关信息，您可以在收到营销信息时，根据信息中的退订提示（如“回复TD退订”），要求顺丰不再向您发送营销信息，顺丰会尊重您的请求。</b>',
					'<b>（五）个人信息主体注销账户 </b>',
					'顺丰速运会员可通过微信公众号、顺丰速运APP或顺丰速运官网会员系统的注销账户页面提交账户注销申请；顺丰国际用户可以自行登录账号后在服务功能界面的注销账户页面提交账户注销申请。月结账户可联系对接销售申请账户注销。 ',
					'<b>（六）响应您的上述请求 </b>',
					'为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。 ',
					'我们将在三十天内做出答复。 ',
					'对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。 ',
					'在以下情形中，按照法律法规要求，我们将无法响应您的请求： ',
					'1、与国家安全、国防安全直接相关的；',
					'2、与公共安全、公共卫生、重大公共利益直接相关的；',
					'3、与犯罪侦查、起诉、审判和判决执行等直接相关的；',
					'4、有充分证据表明您存在主观恶意或滥用权利的；',
					'5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；',
					'6、涉及商业秘密的。'
				]
			},
			{
				name: '<br><b>六、我们如何处理儿童的个人信息 </b>',
				list: [
					'1、顺丰非常重视对儿童个人信息的保护。若您是14周岁以下的儿童，在使用我们的产品与/或服务前，应事先取得您监护人的同意。顺丰根据国家相关法律法规的规定保护儿童的个人信息。',
					'2、我们不会主动直接向儿童收集其个人信息。对于经监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。',
					'3、如果有事实证明儿童并未取得监护人同意的情况下注册使用了我们的产品与/或服务，我们会与相关监护人协商，并设法尽快删除相关个人信息。',
					'4、对于可能涉及的不满14周岁的儿童个人信息，我们进一步采取以下措施予以保障：',
					'	（1）对于收集到的儿童个人信息，我们除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后我们会对儿童个人信息进行删除或匿名化处理。我们会指定专人负责儿童个人信息保护事宜，您也可以通过客服热线95338与我们联系。我们还会制定儿童个人信息保护的内部专门制度。',
					'	（2）当您作为监护人为被监护的儿童选择使用顺丰相关服务时，我们可能需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用晒单、评价及问答功能分享服务相关信息时可能会主动向我们提供儿童个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用我们的产品与/或服务，您应正确引导并予以监护。',
					'	（3）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向我们提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系我们。我们会随时为您提供帮助。'
				]
			},
			{
				name: '<br><b>七、您的个人信息如何在全球范围转移 </b>',
				list: [
					'原则上，我们在某一国家/地区境内收集和产生的个人信息，将存储在该国/地区境内。 ',
					'如您选择顺丰的国际件服务，由于顺丰国际件采取自运营或合作伙伴代理模式，我们会通过系统对接的方式，将国际件<b>运单信息</b>传输给原始收集国/地区以外的国家/地区的关联公司、合作伙伴。此外，<b>为实现本政策所声明的其他目的，您的个人信息亦可能被传输到原始收集国/地区以外的国家/地区。</b>',
					'此类国家/地区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在原始收集国/地区境内足够同等的保护。例如，运单信息采取加密传输、定期评估审计接收方的安全能力水平、签订数据处理协议/条款。'
				]
			},
			{
				name: '<br><b>八、本政策如何更新 </b>',
				list: [
					'我们的隐私政策可能变更。 ',
					'未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。 ',
					'对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件或短信发送通知，说明隐私政策的具体变更内容）。 ',
					'本政策所指的重大变更包括但不限于： ',
					'1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等； ',
					'2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；',
					'3、个人信息共享、转让或公开披露的主要对象发生变化；',
					'4、您参与个人信息处理方面的权利及其行使方式发生重大变化；',
					'5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；',
					'6、个人信息安全影响评估报告表明存在高风险时。'
				]
			},
			{
				name: '<br><b>九、如何联系我们 </b>',
				list: [
					'如果您对本隐私政策有任何疑问、意见或建议，可通过以下方式与我们联系：',
					'顺丰速运有限公司',
					'电 话：95338',
					'注册地址：（中国广东省）深圳市宝安区国际机场航站四路1111号',
					'常用办公地址：中国广东省深圳市南山区学府路深圳软件产业基地一栋B座一楼',
					'一般情况下，我们将在三十天内回复。',
					'如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向您所在国家的监管部门进行投诉或举报，例如中国的网信、电信、公安及工商等监管部门。',
					'<br><b>附则：</b>',
					'<b>如您为下述国家/地区的信息主体，顺丰对您的个人信息的处理分别适用下述隐私政策：</b>',
					'<b>欧盟：<a href="https://www.sf-express.com/gb/sc/Privacy_Policy/" target="_blank">《隐私政策》</a></b>',
					'<b>中国香港/澳门：<a href="https://www.sf-express.com/hk/tc/privacy_policy/privacy_policy.html" target="_blank">私隱政策聲明 《個人資料（私隱）條例》</a></b>',
					'<b>中国台湾：<a href="https://www.sf-express.com/tw/tc/use_clause/privacy_policy.html" target="_blank">私隱政策聲明 《個人資料保護政策》</a></b>',
					'<b>韩国：<a href="https://www.sf-express.com/kr/sc/download/Privacy-Policy-CN.pdf" target="_blank">《个人信息处理方针》</a></b>',
					'<b>日本：<a href="https://www.sf-express.com/jp/sc/Privacy_Policy/Personal-Information-Protection-Policy.html" target="_blank">《个人情报保护方针》</a></b>',
					'<br><br><br>'
				]
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/protocal/terms.js